import { Injectable } from '@angular/core';
declare var $: any;

@Injectable()
export class SettingsService {

    private user: any;
    private app: any;
    private layout: any;
    private summernoteStyleTag: any;
    private summernoteStyleVariables: any = {
        top: 60,
        left: 220
    }

    constructor() {

        // User Settings
        // -----------------------------------
        this.user = {
            name: 'John',
            job: 'ng-developer',
            picture: 'assets/img/user/02.jpg'
        };

        // App Settings
        // -----------------------------------
        this.app = {
            name: 'ITS Teneso',
            description: 'ITS application',
            year: ((new Date()).getFullYear())
        };

        // Layout Settings
        // -----------------------------------
        this.layout = {
            isFixed: true,
            isCollapsed: false,
            isBoxed: false,
            isRTL: false,
            horizontal: false,
            isFloat: false,
            asideHover: false,
            theme: null,
            asideScrollbar: false,
            isCollapsedText: false,
            useFullLayout: false,
            hiddenFooter: false,
            offsidebarOpen: false,
            asideToggled: false,
            viewAnimation: 'ng-fadeInUp'
        };
        this.createStyleForSummerNoteFullscreen();
        this.updateSummernoteStylesheet();
    }

    getAppSetting(name) {
        return name ? this.app[name] : this.app;
    }
    getUserSetting(name) {
        return name ? this.user[name] : this.user;
    }
    getLayoutSetting(name) {
        return name ? this.layout[name] : this.layout;
    }

    setAppSetting(name, value) {
        if (typeof this.app[name] !== 'undefined') {
            this.app[name] = value;
        }
    }
    setUserSetting(name, value) {
        if (typeof this.user[name] !== 'undefined') {
            this.user[name] = value;
        }
    }
    setLayoutSetting(name, value) {
        if (typeof this.layout[name] !== 'undefined') {
            let result = this.layout[name] = value;
            this.updateSummernoteStyleVariables();
            this.updateSummernoteStylesheet();
            return result;
        }
    }

    toggleLayoutSetting(name) {
        return this.setLayoutSetting(name, !this.getLayoutSetting(name));
    }

    private createStyleForSummerNoteFullscreen() {
        const head = document.head || document.getElementsByTagName('head')[0];
        this.summernoteStyleTag = document.createElement('style');
        this.summernoteStyleTag.type = 'text/css';
        this.summernoteStyleTag.id = 'summernoteFullscreen';
        head.appendChild(this.summernoteStyleTag);
    }
      
    private updateSummernoteStylesheet() {
        let css = this.getSummernoteStyle();
        this.summernoteStyleTag.innerHTML = css;
    }

    private updateSummernoteStyleVariables() {
        if(this.layout.isCollapsed) {
            this.summernoteStyleVariables.left = 70;
        } else if(this.layout.isCollapsedText) {
            this.summernoteStyleVariables.left = 90;
        } else {
            this.summernoteStyleVariables.left = 220;
        }
    }
      
    private getSummernoteStyle() {
        let css = `.note-editor.note-frame.fullscreen {
            top: ${this.summernoteStyleVariables.top}px;
            left: ${this.summernoteStyleVariables.left}px;
            right: 0;
            bottom: 0;
            width: auto !important;
        }
        @media (max-width: 767.98px) {
            .note-editor.note-frame.fullscreen {
                left: 0;
            }
        }`;
        return css;
    }
}
